import ThumbProduct from '~/components/ThumbProduct'
import ThumbZoomable from '~/components/ThumbZoomable'
import { Image as ThumbClickable } from '~/components/ThumbZoomable/styles'
import { isPublisher, isReadOnly } from '~/helpers'

import { useMediaReviewTable } from '../../hooks/useMediaReviewTable'
import ReviewActions from './ReviewActions'

import * as S from './styles'

const AdInfo: ReviewRowComponent = data => {
  const { setOpenReviewItemId } = useMediaReviewTable()
  const isPendingReview = data.status === 'pending_review'

  return (
    <S.TitleWrapper>
      {['banner', 'banner_off_site'].includes(data.ad_type) && (
        <>
          {isPendingReview ? (
            <ThumbClickable
              onClick={() => setOpenReviewItemId(data.id)}
              className="imageWrapper"
              data-size="medium"
            >
              <ThumbProduct
                url={data.settings.media_url}
                title={data.media_size}
              />
            </ThumbClickable>
          ) : (
            <ThumbZoomable
              url={data.settings.media_url}
              title={data.media_size}
              size="small"
            />
          )}

          <div className="mainInfo">
            <small>
              <strong>Formato:</strong> {data.settings.ad_size}
            </small>
          </div>

          {isPendingReview && isPublisher() && !isReadOnly() && (
            <ReviewActions adId={data.id} />
          )}
        </>
      )}
    </S.TitleWrapper>
  )
}

export default AdInfo
